import { render, staticRenderFns } from "./CookiesPolicy.vue?vue&type=template&id=6c25573e&scoped=true"
import script from "./CookiesPolicy.vue?vue&type=script&lang=js"
export * from "./CookiesPolicy.vue?vue&type=script&lang=js"
import style0 from "./CookiesPolicy.vue?vue&type=style&index=0&id=6c25573e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c25573e",
  null
  
)

export default component.exports